/* Cure House shared behaviour. Ported from the mockup site.js with one
   structural change: the theme class lives on <html> (documentElement), not
   <body>, so the pre-paint inline script in theme.liquid can set it before
   first paint. All handlers are defensive: a page may lack any component. */
(function () {
  var root = document.documentElement, KEY = 'bealsTheme';

  /* ---- theme toggle (class is already set pre-paint; this only flips it) ---- */
  var themeBtn = document.getElementById('themeToggle');
  if (themeBtn) themeBtn.addEventListener('click', function () {
    var toLight = root.classList.contains('t-dark');
    root.classList.toggle('t-dark', !toLight);
    root.classList.toggle('t-light', toLight);
    try { localStorage.setItem(KEY, toLight ? 'light' : 'dark'); } catch (e) {}
  });

  /* ---- search panel ---- */
  var sp = document.getElementById('searchPanel'),
      sBtn = document.getElementById('searchToggle'),
      sClose = document.getElementById('searchClose');
  function setSearch(open) {
    if (!sp) return;
    sp.classList.toggle('open', open);
    if (sBtn) sBtn.setAttribute('aria-expanded', open);
    var f = sp.querySelector('input[type="search"]');
    if (open && f) setTimeout(function () { f.focus(); }, 60);
  }
  if (sBtn) sBtn.addEventListener('click', function () { setSearch(!sp.classList.contains('open')); });
  if (sClose) sClose.addEventListener('click', function () { setSearch(false); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setSearch(false); });

  /* ---- mobile menu ---- */
  var burger = document.querySelector('.cure .burger');
  if (burger) burger.addEventListener('click', function () {
    var ul = document.querySelector('.cure .navCenter ul');
    if (!ul) return;
    var open = ul.style.display === 'flex';
    ul.style.cssText = open ? '' :
      'display:flex;position:absolute;left:0;right:0;top:100%;flex-direction:column;gap:0;' +
      'background:var(--bg2);border-bottom:1px solid var(--line2);padding:14px 22px;z-index:120';
  });
})();

/* ---- No-reload filtering on the collection page (Sam, QA round 4) ----
   Intercepts chip/pagination clicks and filter/sort form submits inside
   [data-cure-collection], fetches the target URL, and swaps the whole section
   in place. Plain GET navigation remains the no-JS fallback. */
(function () {
  var SEL = '[data-cure-collection]';
  if (!document.querySelector(SEL)) return;

  function swap(url, push) {
    var root = document.querySelector(SEL);
    if (!root) { window.location.href = url; return; }
    root.setAttribute('aria-busy', 'true');
    root.style.opacity = '.55';
    fetch(url).then(function (r) {
      if (!r.ok) throw new Error(r.status);
      return r.text();
    }).then(function (html) {
      var next = new DOMParser().parseFromString(html, 'text/html').querySelector(SEL);
      if (!next) { window.location.href = url; return; }
      root.replaceWith(next);
      if (push) history.pushState({ cure: true }, '', url);
      document.dispatchEvent(new CustomEvent('cure:collection:updated'));
    }).catch(function () { window.location.href = url; });
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest(SEL + ' .chips a, ' + SEL + ' .btn.ghost[href]');
    if (!a || e.metaKey || e.ctrlKey || e.shiftKey) return;
    e.preventDefault();
    swap(a.href, true);
  });

  document.addEventListener('submit', function (e) {
    var f = e.target.closest(SEL + ' form');
    if (!f || f.method.toLowerCase() !== 'get') return;
    e.preventDefault();
    var qs = new URLSearchParams(new FormData(f)).toString();
    swap(f.getAttribute('action') + (qs ? '?' + qs : ''), true);
  });

  window.addEventListener('popstate', function () {
    if (document.querySelector(SEL)) swap(window.location.href, false);
  });
})();

/* ---- Predictive search (Sam: results under the bar, no Enter needed) ----
   Debounced call to Shopify's suggest endpoint; product rows render under the
   field. The form still submits normally to the full results page. */
(function () {
  var panel = document.getElementById('searchPanel');
  if (!panel) return;
  var input = panel.querySelector('[data-cure-search-input]');
  var box = panel.querySelector('[data-cure-search-results]');
  var form = panel.querySelector('form');
  if (!input || !box) return;
  var searchUrl = (form && form.getAttribute('action')) || '/search';
  var timer = null, controller = null, lastQ = '';

  function titleCase(s) {
    return String(s).toLowerCase().replace(/(^|[\s(\/&-])([a-z])/g,
      function (m, pre, c) { return pre + c.toUpperCase(); });
  }
  function money(v) { return '£' + Number(v).toFixed(2); }
  function hide() { box.hidden = true; box.textContent = ''; }

  function render(products, q) {
    box.textContent = '';
    if (!products.length) {
      var none = document.createElement('p');
      none.className = 'snone';
      none.textContent = 'Nothing matched that yet. Try a shorter word.';
      box.appendChild(none);
    } else {
      products.forEach(function (p) {
        var a = document.createElement('a');
        a.className = 'srow';
        a.href = p.url;
        var th = document.createElement('span');
        th.className = 'sthumb';
        if (p.image) {
          var im = document.createElement('img');
          im.src = p.image + (p.image.indexOf('?') > -1 ? '&' : '?') + 'width=120';
          im.alt = '';
          im.width = 120; im.height = 120;
          th.appendChild(im);  // not lazy: the row is on screen the moment it renders
        }
        var t = document.createElement('span');
        t.className = 'stitle';
        t.textContent = titleCase(p.title);
        var pr = document.createElement('span');
        pr.className = 'sprice';
        var varies = p.price_min && p.price_max && p.price_min !== p.price_max;
        pr.textContent = (varies ? 'From ' : '') + money(p.price_min || p.price);
        a.appendChild(th); a.appendChild(t); a.appendChild(pr);
        box.appendChild(a);
      });
    }
    var all = document.createElement('a');
    all.className = 'sall';
    all.href = searchUrl + '?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last';
    all.textContent = products.length ? 'See all results' : 'Search the whole counter';
    box.appendChild(all);
    box.hidden = false;
  }

  function run(q) {
    if (controller) controller.abort();
    controller = ('AbortController' in window) ? new AbortController() : null;
    fetch(searchUrl + '/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product&resources[limit]=5',
      controller ? { signal: controller.signal } : undefined)
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (input.value.trim() !== q) return;  // a newer keystroke won
        render((d.resources && d.resources.results && d.resources.results.products) || [], q);
      })
      .catch(function () {});
  }

  input.addEventListener('input', function () {
    var q = input.value.trim();
    clearTimeout(timer);
    if (q.length < 2) { lastQ = ''; hide(); return; }
    if (q === lastQ) return;
    timer = setTimeout(function () { lastQ = q; run(q); }, 300);
  });

  input.addEventListener('keydown', function (e) {
    if (e.key !== 'ArrowDown' || box.hidden) return;
    var first = box.querySelector('.srow, .sall');
    if (first) { e.preventDefault(); first.focus(); }
  });

  box.addEventListener('keydown', function (e) {
    if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
    var items = Array.prototype.slice.call(box.querySelectorAll('.srow, .sall'));
    var i = items.indexOf(document.activeElement);
    e.preventDefault();
    if (e.key === 'ArrowDown') { if (items[i + 1]) items[i + 1].focus(); }
    else if (i > 0) { items[i - 1].focus(); } else { input.focus(); }
  });

  if ('MutationObserver' in window) {
    new MutationObserver(function () {
      if (!panel.classList.contains('open')) hide();
    }).observe(panel, { attributes: true, attributeFilter: ['class'] });
  }
})();

/* ---- Signup popup ("10% off your first order — join the list") ----
   Shows once after a delay; a dismissal is remembered for data-dismiss-days,
   a signup for good. Shopify reloads with ?customer_posted=true after the
   form posts — that reopens the popup in its success state with the code. */
(function () {
  var popup = document.querySelector('[data-cure-popup]');
  if (!popup) return;
  var KEY = 'bealsPopup';

  function state() {
    try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch (e) { return {}; }
  }
  function save(s) { try { localStorage.setItem(KEY, JSON.stringify(s)); } catch (e) {} }

  function open(success) {
    if (success) {
      popup.querySelector('[data-popup-form-state]').hidden = true;
      popup.querySelector('[data-popup-success-state]').hidden = false;
    }
    popup.hidden = false;
    document.addEventListener('keydown', onKey);
  }
  function close() {
    popup.hidden = true;
    document.removeEventListener('keydown', onKey);
    var s = state();
    if (!s.done) { s.dismissedAt = Date.now(); save(s); }
  }
  function onKey(e) { if (e.key === 'Escape') close(); }

  popup.addEventListener('click', function (e) {
    if (e.target.closest('[data-popup-close]')) close();
    var code = e.target.closest('[data-popup-code]');
    if (code && navigator.clipboard) {
      navigator.clipboard.writeText(code.textContent.trim()).then(function () {
        var hint = popup.querySelector('[data-popup-code-hint]');
        if (hint) hint.textContent = 'Copied. See you at checkout.';
      }).catch(function () {});
    }
  });

  var s = state();
  if (new URLSearchParams(location.search).get('customer_posted') === 'true') {
    s.done = true; save(s);
    open(true);
    return;
  }
  if (s.done) return;
  var days = parseInt(popup.getAttribute('data-dismiss-days'), 10) || 30;
  if (s.dismissedAt && Date.now() - s.dismissedAt < days * 864e5) return;
  var delay = (parseInt(popup.getAttribute('data-delay'), 10) || 6) * 1000;
  setTimeout(function () { open(false); }, delay);
})();

/* ---- AJAX add to basket (Sam, mobile QA) ----
   The product form no longer bounces to /cart: it posts via /cart/add.js and a
   confirmation card offers View basket / Keep shopping. Plain POST remains the
   no-JS fallback, and any AJAX failure falls back to a native submit. */
(function () {
  var toast = null, hideTimer = null, busy = false;

  function cartUrl() {
    var a = document.querySelector('.cure .cartlink');
    return a ? a.getAttribute('href') : '/cart';
  }

  function ensureToast() {
    if (toast) return toast;
    var root = document.querySelector('.cure');
    if (!root) return null;
    toast = document.createElement('div');
    toast.className = 'atcToast';
    toast.setAttribute('role', 'status');
    toast.innerHTML = '<p></p><div class="row">' +
      '<a class="btn" href="' + cartUrl() + '">View basket</a>' +
      '<button type="button" class="btn ghost" data-atc-close>Keep shopping</button></div>';
    toast.addEventListener('click', function (e) {
      if (e.target.closest('[data-atc-close]')) hide();
    });
    root.appendChild(toast);
    return toast;
  }

  function hide() {
    clearTimeout(hideTimer);
    if (toast) toast.classList.remove('show');
  }

  function show(msg) {
    var t = ensureToast();
    if (!t) return;
    t.querySelector('p').textContent = msg;
    t.classList.add('show');
    clearTimeout(hideTimer);
    hideTimer = setTimeout(hide, 7000);
  }

  function refreshCount() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      document.querySelectorAll('.cure .cartlink').forEach(function (a) {
        a.textContent = 'Basket · ' + c.item_count;
      });
    }).catch(function () {});
  }

  document.addEventListener('submit', function (e) {
    var f = e.target.closest('.cure form.buyrow');
    if (!f || busy) return;
    e.preventDefault();
    busy = true;
    var btn = f.querySelector('[data-cure-add]');
    if (btn) btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: new FormData(f)
    }).then(function (r) {
      return r.json().then(function (j) { return { ok: r.ok, j: j }; });
    }).then(function (res) {
      if (res.ok) {
        refreshCount();
        show('Added to your basket.');
      } else {
        show(res.j && res.j.description ? res.j.description : 'That could not be added. Try again.');
      }
    }).catch(function () {
      busy = false;
      if (btn) btn.disabled = false;
      f.submit();
    }).finally(function () {
      busy = false;
      if (btn) btn.disabled = false;
    });
  });
})();

/* ---- Mobile filter collapse (Sam, mobile QA) ----
   Under 1100px the filter panel stacks above the grid, so it starts collapsed
   behind a "Filter products" button. Delegated so it survives AJAX swaps, and
   the open state is restored after a swap so filtering stays uninterrupted. */
(function () {
  var open = false;

  function apply() {
    var btn = document.querySelector('[data-filters-toggle]');
    var panel = btn && document.getElementById(btn.getAttribute('aria-controls'));
    if (!btn || !panel) return;
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    panel.classList.toggle('open', open);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-filters-toggle]');
    if (!btn) return;
    open = !open;
    apply();
  });

  document.addEventListener('cure:collection:updated', apply);
})();

/* ---- Infinite scroll on the collection grid (Sam, QA round 6) ----
   When the pager scrolls into view, fetch the next page and append its cards.
   The numeric pager stays as the no-JS fallback; with JS it becomes a quiet
   "loading more" sentinel. Re-arms after every AJAX filter/sort swap. */
(function () {
  var observer = null;

  function arm() {
    if (observer) { observer.disconnect(); observer = null; }
    var pager = document.querySelector('[data-cure-pagination]');
    if (!pager) return;
    if (!pager.getAttribute('data-next-url')) { pager.remove(); return; }
    pager.innerHTML = '<span class="chip" aria-hidden="true">Loading more…</span>';
    observer = new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting) return;
      var url = pager.getAttribute('data-next-url');
      if (!url || pager.dataset.loading) return;
      pager.dataset.loading = '1';
      fetch(url).then(function (r) {
        if (!r.ok) throw new Error(r.status);
        return r.text();
      }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newGrid = doc.querySelector('[data-cure-grid]');
        var grid = document.querySelector('[data-cure-grid]');
        if (newGrid && grid) {
          while (newGrid.firstChild) grid.appendChild(newGrid.firstChild);
          // Default sort partitions sold-out per page server-side (Liquid);
          // after each append, sink every sold-out card so the partition stays
          // global across the stitched pages. Skip on explicit sorts to match.
          if (url.indexOf('sort_by=') === -1) {
            grid.querySelectorAll('[data-soldout]').forEach(function (c) {
              grid.appendChild(c);
            });
          }
        }
        var newPager = doc.querySelector('[data-cure-pagination]');
        var nextUrl = newPager && newPager.getAttribute('data-next-url');
        delete pager.dataset.loading;
        if (nextUrl) {
          pager.setAttribute('data-next-url', nextUrl);
        } else {
          if (observer) observer.disconnect();
          pager.remove();
        }
      }).catch(function () {
        delete pager.dataset.loading;
        pager.removeAttribute('data-next-url');
      });
    }, { rootMargin: '600px 0px' });
    observer.observe(pager);
  }

  if (document.querySelector('[data-cure-pagination]') || document.querySelector('[data-cure-collection]')) {
    arm();
    document.addEventListener('cure:collection:updated', arm);
  }
})();

/* ---- Order-by line, global (18 Sep 2026) ----
   Same logic as the product section's inline handler, applied to every
   [data-cure-promise] on the page so the cart (and anything else) shows the
   same before/after cut-off text as the product page. Cut-off day/hour and
   both texts come from Theme settings > Delivery via data attributes. */
(function () {
  var els = document.querySelectorAll('[data-cure-promise]');
  if (!els.length) return;
  var parts;
  try {
    parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', weekday: 'short', hour: 'numeric', hour12: false }).formatToParts(new Date());
  } catch (e) { return; }
  var days = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
  var wd = null, hr = null;
  for (var i = 0; i < parts.length; i++) {
    if (parts[i].type === 'weekday') wd = days[parts[i].value];
    if (parts[i].type === 'hour') hr = parseInt(parts[i].value, 10);
  }
  if (wd === null || hr === null || isNaN(hr)) return;
  for (var k = 0; k < els.length; k++) {
    var el = els[k];
    var out = el.querySelector('[data-cure-promise-text]');
    var cutDay = parseInt(el.getAttribute('data-cutoff-day'), 10);
    var cutHour = parseInt(el.getAttribute('data-cutoff-hour'), 10);
    if (!out || isNaN(cutDay) || isNaN(cutHour)) continue;
    var before = (wd < cutDay) || (wd === cutDay && hr < cutHour);
    if (wd === 0) before = false; /* Sunday sits after Saturday in the week */
    out.textContent = before ? el.getAttribute('data-before') : el.getAttribute('data-after');
  }
})();
